const html = document.documentElement;

export default {
  mounted() {
    html.classList.add('has-popup');
  },
  beforeDestroy() {
    html.classList.remove('has-popup');
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
